import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-change-environment',
  templateUrl: './change-environment.component.html',
  styleUrls: ['./change-environment.component.scss']
})
export class ChangeEnvironmentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
